<template>
  <div>
    <img :src="require('@/assets/bg.png')" class="main">
   <div class="container-fluid row pt-3">
    <nav class="container mx-auto navbar navbar-expand-lg navbar-dark nav-dark pt-5">
        <a href="/" class="navbar-brand">
         <img src="@/assets/logo.png">
      <!-- <h6 class="text-light">TESTNET</h6> -->
        
        </a>
    </nav>
   </div>
  
   <div id="loading" v-if="show.showLoading">
    <div class="content">

      <v-icon name="spinner" pulse scale="3" />

    </div>
  </div>

    <div class="container-fluid d-flex justify-content-center">
      <div class="col col-md-6 col-sm-6 pt-3">
              <div class="input-group mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="search"></b-icon>
                </b-input-group-prepend>
                <input v-model="init.search" v-on:keyup.enter="search" type="text" class="form-control" placeholder="Transaction or Wallet Address">

                <!-- <div v-for="l of resultSearch" :key="l.id">{{l.hash}}</div> -->
              </div>
      </div>
    </div>

   <!--chart-->
   <!-- <div class="container-fluid row">
          <div class="col col-md-6 col-sm-12">
              <h6 class="text-white">Total Transactions</h6>

              <div>
                <div class="chart-loading">
                 
                </div>
              </div>
              <div class="card no-gutter card-cascade narrower shadow ">

                <div class="card-body fiat view view-cascade ">
                  <canvas id="blockChart"></canvas>
                </div>
              </div>
            </div>

             <div class="col col-md-6 col-sm-12">
              <h6 class="text-white">Total Blocks</h6>

              <div>
                <div class="chart-loading">
                 
                </div>
              </div>
              <div class="card no-gutter card-cascade narrower shadow ">

                <div class="card-body fiat view view-cascade ">
                  <canvas id="blockChart"></canvas>
                </div>
              </div>
            </div>
   </div> -->
<!--//-->


      <div class="bg2 no-gutter container-fluid">
        <div class="row main-content" >

          <div class="right">
            <div>
            <h6 class="title text-white pt-5 mt-5">All Transactions</h6>
            <h6>Total Number of transactions: {{totalTransactions}} </h6>
            </div>
            <div class="table-responsive text-white container-fluid">
            <table id="blocks">
                <thead>
                  <tr >
                    <th>Txn Hash</th>
                    <th>Wallet Address</th>
                    <th>Amount</th>
                    <th>Symbol</th>
                    <th>Timestamp</th>
                    <th>Confirmations</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody class="tbody">
                  <tr v-if="bloxdaoToBLOX.length == 0">
                    <td colspan="7"> No Transaction Found</td>
                  </tr>
                  <tr v-for="txn in bloxdaoToBLOX" :key="txn.id">

                    <td class="text-left" id="hash"> <a :href="'#/transaction/' + txn.hash"> {{ txn.hash | truncate(35)}}</a> </td>

                    <td class="text-left" id="hash">{{ txn.recipient | truncate(35)}}</td>
                   <td class="text-left">{{  formatAmount(txn.amount)}}</td>
                    <td> {{txn.symbol}}</td>
                    <td>{{ formatDate(txn.input.timeStamp) }}</td> 
                    <td class="text-center">{{ txn.confirmations }}</td> 
                    <td class="text-center" v-if="txn.confirmations >=1">CONFIRMED</td> 
                    <td class="text-center" v-else>UNCONFIRMED</td> 


                   </tr>
                </tbody>
              </table> 
              <div class="pagination" v-if="bloxdaoToBLOX.length > 30">
						  <button class="a" @click="prevPage">Previous</button> 
  						<button class="a" @click="nextPage">Next</button>
				    </div>
           
          </div>
          </div>

        </div>
      </div>
   </div>
</template>

<script>
import moment from 'moment'
import SearchModal from "../components/Modal/SearchModal.vue"
import numeral from 'numeral'
import axios from "axios";
// import Chart from 'chart.js'

export default {
  name: 'Transactions',
  components: {
    SearchModal
  },
  data: () => ({
      status:'',
      txnList: [],
      totalTransactions: '',
      busy: false

      
  }),
  computed: {
        init() {
            return this.$store.state.init;
        },

        errors() {
            return this.$store.state.errors;
        },

        show() {
            return this.$store.state.show;
        },

        action() {
            return this.$store.state.action;
        },

        list() {
            return this.$store.state.list;
        },
        rows() {
            return this.txnList.length
        },
        bloxdaoToBLOX: function() {
          return this.txnList.filter(function(txn) {
            if(txn.symbol == 'BLOXDAO' || txn.symbol == 'bloxdao'){ 
              return txn.symbol = 'BLOX';
            } else {
              return txn.symbol
            }
        })
      },
        
        
  },
  methods: {
   
    getSize: function(data) {

      return unescape(encodeURIComponent(data)).length + " bytes";
    },
    
    formatDate: function(date) {
           // return date;
        if(date != undefined) {
             return moment(new Date(date)).format('MM/DD/YYYY hh:mm:ss A');
           }
    },
    formatAmount:  function (num) {

      if(isNaN(num)) {
        num = 0;
      }
      return parseFloat(num).toFixed(8)
    },
    
    getListBlocks: function(){
      this.show.showLoading = true;
        this.axios.get('/blx-api/blocks/page', {
              headers: { 'content-type': 'application/x-www-form-urlencoded' },
              params: {
                page: this.init.page,
                itemsPerPage: this.init.itemsPerPage
              },
          }).then((response) => {
          this.list.blocks = response.data;
          setTimeout(() => {
                    this.show.showLoading = false;
                  }, 1000);
        

          //for txn list
          this.txnList = [];
          response.data.forEach((el, i) => {
            for(var key in el.data) {
              this.txnList.push(el.data[key])
            }
            //console.log(this.txnList)
            //this.txnList.push(el.data);
          })
          this.txnList = this.txnList
        });
      },
      nextPage:function() {
          this.init.page ++ ;
          this.getListBlocks();

          if(this.list.blocks.length < 30){
            this.init.page --;
          }
          
      
		  },
		  prevPage:function() {
			if(this.init.page > 1) {
				this.init.page --;
				this.getListBlocks();
			}
		},

    getTotalCount: function(){
      this.axios.get('/blx-api/blocks/details', {
         headers: { 'content-type': 'application/x-www-form-urlencoded' },
      }).then((response) => {
        //console.log(response.data)
        this.totalTransactions = response.data.totalTransactionsCount;
        this.show.showLoading = false;
      })
    },

    search: function(){
            if(this.init.search == "BIXIE" || this.init.search == "bixie") {
              this.$router.push('/bixie/')
            }
            if(this.init.search == "GWX" || this.init.search == "gwx") {
              this.$router.push('/gwx/')
            }
            if(this.init.search == "BLOXDAO" || this.init.search == "bloxdao") {
              this.$router.push('/blox/')
            }
            if(this.init.search == "BLX" || this.init.search == "blx") {
              this.$router.push('/blx/')
            }
    
            if(this.init.search.length == 32 || this.init.search.length == 33 || this.init.search.length == 42 || this.init.search.length == 34 || this.init.search.length == 35) {
              this.$router.push('/search-network/')
              localStorage.setItem("walletAddress", this.init.search);
            } else if(this.init.search.length == 64){
               this.$router.push('/transaction/' + this.init.search)
              if(this.$router.currentRoute.name == 'Transaction') {
                    window.location.reload();
                  }
            } else {
              this.$router.push('/notfound/' + this.init.search);
              if(this.$router.currentRoute.name == 'NotFound') {
                  window.location.reload();
              }

            }
          },
 
  },
  beforeMount(){
    this.getListBlocks();
  },
  mounted: function(){
    this.getTotalCount();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main{
    background-image: url('../assets/bg.png');
    background-repeat: no-repeat;
    height: 100%;
    width: 100%;
    background-position: center;
    background-size: cover;
    padding-bottom: 300px;
}
.text-left {
  text-align: left;
}

.navbar-brand img{
  width: 10rem;
  margin: auto 100px;
}
.form-control{
 font-size: 10px;
}
.title{
  text-align: left;
  margin: 0 10px;
  padding: 0.5em 2em;
}
table {
    border-collapse: collapse;
    width: 100% !important;
    margin: 0 10px;
    background: #414141 !important;
    color: white;
    text-align: center !important;
    font-size: 80%;
    border-radius: 10px !important;
    padding: 0.5em 2em;
}
th, td {
  padding: 0.5em;
}
tr{
  border-top: 1px solid grey;
  width: 100%;
  padding: 0.5em 2em;
}
#blocks thead{
  background-color: #808080;
  width: 100%;
  color: white;
  font-size: 0.875rem;
  letter-spacing: 2%;
  border-radius: 10px !important;
}
table a{
  color: #c68b17;
  text-decoration: none;
}



h6{
  color: white;
}
.container{
  z-index: 9999 !important;
}
.container-fluid{
  z-index: 9999 !important;

}
.pagination{
		padding: 10px;
		display: flex;
		justify-content: center;
	}
	.page{
		padding: 10px;
		display: flex;
		justify-content: center;
		text-align: center;
		color: white;
		width: auto;
	}
	.pagination .a {
		width: 100px;
		color: black;
		float: left;
		padding: 8px 16px;
		text-decoration: none;
		transition: background-color .3s;
		background-color:white !important;
		border-radius: 10px;
	}

	.pagination .a:hover {
		background-color: #c68b17 !important;
		color: white;
	}

	.pagination .a:hover:not(.active) {background-color: #c68b17;}

@media (min-width: 576px) and (max-width: 767.98px) { 
    *{
        overflow-x: hidden;
    }
  }
</style>
